import { defer, of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { schedulerNow } from '../utils/now';
export var queueTime = function (timeDelay, scheduler) {
    return function (source) { return defer(function () {
        var nextEarliestEmission = null;
        return source.pipe(concatMap(function (value) {
            var now = schedulerNow(scheduler);
            var expectedEmissionTime = nextEarliestEmission;
            if (expectedEmissionTime === null || now > expectedEmissionTime) {
                nextEarliestEmission = now + timeDelay;
                return of(value);
            }
            else {
                var requiredDelay = expectedEmissionTime - now;
                nextEarliestEmission = now + timeDelay + requiredDelay;
                return of(value).pipe(delay(requiredDelay, scheduler));
            }
        }));
    }); };
};
//# sourceMappingURL=queueTime.js.map